/** ProjectCloseoutRoute — skin-aware switcher for /closeout. */
import { useUISkin } from "@/data/UISkinContext";
import ProjectCloseout from "./ProjectCloseout";
import ProjectCloseoutCockpit from "./ProjectCloseoutCockpit";

export default function ProjectCloseoutRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ProjectCloseoutCockpit />;
  return <ProjectCloseout />;
}
